import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import React from 'react'

import Tooltip from '@/app/component/atom/tooltip'

import { EllipsisTypography, FlexContainerCenter } from './common'

export type Props = {
  campaignName: string
  userStatuses: string[]
  userStatus?: string
  onEditStatus: () => void
}

const CampaignHeader: React.FC<Props> = ({ campaignName, userStatuses, userStatus, onEditStatus }) => (
  <PageTitleContainer>
    <Tooltip title={campaignName}>
      <EllipsisTypography variant="h5" color="textSecondary">
        {campaignName || ''}
      </EllipsisTypography>
    </Tooltip>
    {userStatuses && userStatuses.length > 0 && (
      <FlexContainerCenter>
        <Typography variant="body2" color="textSecondary" id="cati-status-text">
          {userStatus ? `Status: ${userStatus}` : 'Set status'}
        </Typography>
        <IconButton id="cati-edit-status" onClick={onEditStatus}>
          <EditIcon fontSize="small" sx={{ fontSize: '1rem', padding: 0 }} />
        </IconButton>
      </FlexContainerCenter>
    )}
  </PageTitleContainer>
)

const PageTitleContainer = styled('div')({
  width: '50%',
  textAlign: 'left',
  marginRight: '30px',
})

export default CampaignHeader
